import React from 'react';
import { Layout, Typography, Divider, Space, message, Row, Col } from 'antd';
import { CopyOutlined, LinkedinOutlined, LockOutlined } from '@ant-design/icons';
import icon from "../../icons/icon-logo-white.svg";
import "./LoginFooter.css";

const { Footer: AntFooter } = Layout;
const { Text, Link, Title } = Typography;

export type FooterType = {
  className?: string;
};

const Footer: React.FC<FooterType> = ({ className = "" }) => {
  const handleEmailClick = () => {
    const email = 'info@tommy.ai';
    navigator.clipboard.writeText(email).then(() => {
      message.success('Email copied to clipboard');
    }).catch(err => {
      console.error('Failed to copy email: ', err);
    });
  };

  return (
    <AntFooter className={`footer-wrapper ${className}`} style={{ padding: '24px 50px', background: 'transparent' }}>
      <Divider style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }} />
      <Row justify="space-around" align="top" gutter={[24, 24]}>
        <Col xs={24} sm={8} style={{ textAlign: 'center' }}>
          <Space align="center">
            <img
              src={icon}
              alt="Tommy.ai Logo"
              style={{ height: 24 }}
            />
            <Text style={{color: 'white'}}>@ Tommy.ai Technologies</Text>
          </Space>
        </Col>
        
        <Col xs={12} sm={8} style={{ textAlign: 'center' }}>
          <Title level={5} style={{ color: 'white', marginBottom: '16px' }}>Resources</Title>
          <Space direction="vertical">
            <Link href="/privacy" style={{ color: 'white' }}><LockOutlined /> Privacy</Link>
          </Space>
        </Col>
        
        <Col xs={12} sm={8} style={{ textAlign: 'center' }}>
          <Title level={5} style={{ color: 'white', marginBottom: '16px' }}>Contacts</Title>
          <Space direction="vertical">
            <Link href="https://www.linkedin.com/company/tommy-ai" target="_blank" style={{ color: 'white' }}>
              <LinkedinOutlined /> LinkedIn
            </Link>
            <Link onClick={handleEmailClick} style={{ color: 'white' }}>
              <CopyOutlined /> Email
            </Link>
          </Space>
        </Col>
      </Row>
    </AntFooter>
  );
};

export default Footer;